import { createSlice } from '@reduxjs/toolkit';

export interface PostState {
  isPostMode: boolean;
  isShowPostConfirmMessage: boolean;
  isClickLngLatUpdateEnabled: boolean;
  clickLngLat?: [number, number];
  ownedPostIds: string[];
  prevPath: string;
  isFromCurrentLocation: boolean;
}

const initialState: PostState = {
  isPostMode: false,
  isClickLngLatUpdateEnabled: true,
  isShowPostConfirmMessage: false,
  clickLngLat: undefined,
  ownedPostIds: [],
  prevPath: 'post',
  isFromCurrentLocation: false,
};

export const authenticatorSlice = createSlice({
  name: 'post',
  initialState,
  reducers: {
    enablePostMode: (state) => {
      state.isPostMode = true;
    },
    setIsShowPostConfirmMessage: (state, action) => {
      state.isShowPostConfirmMessage = action.payload;
    },
    disablePostMode: (state) => {
      state.isPostMode = false;
      state.clickLngLat = undefined;
      state.isClickLngLatUpdateEnabled = true;
      state.isShowPostConfirmMessage = false;
    },
    setClickLngLat: (state, action) => {
      state.clickLngLat = action.payload;
    },
    setIsClickLngLatUpdateEnabled: (state, action) => {
      state.isClickLngLatUpdateEnabled = action.payload;
    },
    setOwnedPostIds: (state, action) => {
      state.ownedPostIds = action.payload;
    },
    setPrevPath: (state, action) => {
      state.prevPath = action.payload;
    },
    setIsFromCurrentLocation: (state, action) => {
      state.isFromCurrentLocation = action.payload;
    },
  },
});

export const {
  reducer: postReducer,
  actions: {
    enablePostMode,
    setIsShowPostConfirmMessage,
    disablePostMode,
    setIsClickLngLatUpdateEnabled,
    setClickLngLat,
    setOwnedPostIds,
    setPrevPath,
    setIsFromCurrentLocation,
  },
} = authenticatorSlice;
